module.exports = __webpack_public_path__ + "static/media/gautierValdiguie.d9fbf170.png";